/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0ConstructionsiteCreateConstructionSitePost } from '../fn/construction-site/api-v-0-constructionsite-create-construction-site-post';
import { ApiV0ConstructionsiteCreateConstructionSitePost$Params } from '../fn/construction-site/api-v-0-constructionsite-create-construction-site-post';
import { apiV0ConstructionsiteDeleteConSiteIdDelete } from '../fn/construction-site/api-v-0-constructionsite-delete-con-site-id-delete';
import { ApiV0ConstructionsiteDeleteConSiteIdDelete$Params } from '../fn/construction-site/api-v-0-constructionsite-delete-con-site-id-delete';
import { apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json } from '../fn/construction-site/api-v-0-constructionsite-get-construction-sites-by-company-get-json';
import { ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json$Params } from '../fn/construction-site/api-v-0-constructionsite-get-construction-sites-by-company-get-json';
import { apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain } from '../fn/construction-site/api-v-0-constructionsite-get-construction-sites-by-company-get-plain';
import { ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Params } from '../fn/construction-site/api-v-0-constructionsite-get-construction-sites-by-company-get-plain';
import { apiV0ConstructionsiteSetConstructionSiteStatePost } from '../fn/construction-site/api-v-0-constructionsite-set-construction-site-state-post';
import { ApiV0ConstructionsiteSetConstructionSiteStatePost$Params } from '../fn/construction-site/api-v-0-constructionsite-set-construction-site-state-post';
import { apiV0ConstructionsiteUpdatePut } from '../fn/construction-site/api-v-0-constructionsite-update-put';
import { ApiV0ConstructionsiteUpdatePut$Params } from '../fn/construction-site/api-v-0-constructionsite-update-put';
import { ConstructionSite } from '../models/construction-site';

@Injectable({ providedIn: 'root' })
export class ConstructionSiteService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0ConstructionsiteGetConstructionSitesByCompanyGet()` */
  static readonly ApiV0ConstructionsiteGetConstructionSitesByCompanyGetPath = '/api/v0/constructionsite/getConstructionSitesByCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Response(params?: ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionSite>>> {
    const obs = apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain(params?: ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Params, context?: HttpContext): Observable<Array<ConstructionSite>> {
    const resp = this.apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConstructionSite>>): Array<ConstructionSite> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json$Response(params?: ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConstructionSite>>> {
    const obs = apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json(params?: ApiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json$Params, context?: HttpContext): Observable<Array<ConstructionSite>> {
    const resp = this.apiV0ConstructionsiteGetConstructionSitesByCompanyGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ConstructionSite>>): Array<ConstructionSite> => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructionsiteCreateConstructionSitePost()` */
  static readonly ApiV0ConstructionsiteCreateConstructionSitePostPath = '/api/v0/constructionsite/createConstructionSite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructionsiteCreateConstructionSitePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructionsiteCreateConstructionSitePost$Response(params?: ApiV0ConstructionsiteCreateConstructionSitePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructionsiteCreateConstructionSitePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructionsiteCreateConstructionSitePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructionsiteCreateConstructionSitePost(params?: ApiV0ConstructionsiteCreateConstructionSitePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructionsiteCreateConstructionSitePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructionsiteUpdatePut()` */
  static readonly ApiV0ConstructionsiteUpdatePutPath = '/api/v0/constructionsite/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructionsiteUpdatePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructionsiteUpdatePut$Response(params?: ApiV0ConstructionsiteUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructionsiteUpdatePut(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructionsiteUpdatePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructionsiteUpdatePut(params?: ApiV0ConstructionsiteUpdatePut$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructionsiteUpdatePut$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructionsiteDeleteConSiteIdDelete()` */
  static readonly ApiV0ConstructionsiteDeleteConSiteIdDeletePath = '/api/v0/constructionsite/delete/{conSiteId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructionsiteDeleteConSiteIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructionsiteDeleteConSiteIdDelete$Response(params: ApiV0ConstructionsiteDeleteConSiteIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructionsiteDeleteConSiteIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructionsiteDeleteConSiteIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConstructionsiteDeleteConSiteIdDelete(params: ApiV0ConstructionsiteDeleteConSiteIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructionsiteDeleteConSiteIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV0ConstructionsiteSetConstructionSiteStatePost()` */
  static readonly ApiV0ConstructionsiteSetConstructionSiteStatePostPath = '/api/v0/constructionsite/setConstructionSiteState';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConstructionsiteSetConstructionSiteStatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructionsiteSetConstructionSiteStatePost$Response(params?: ApiV0ConstructionsiteSetConstructionSiteStatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConstructionsiteSetConstructionSiteStatePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConstructionsiteSetConstructionSiteStatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConstructionsiteSetConstructionSiteStatePost(params?: ApiV0ConstructionsiteSetConstructionSiteStatePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConstructionsiteSetConstructionSiteStatePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
